/* hs-eslint ignored failing-rules */

'use es6';

import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { List, Map as ImmutableMap } from 'immutable';
import GenericInboxForm from '../form/GenericInboxForm';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Box } from 'foundations-components/transitional/components/Box';
import { Text } from 'foundations-components/components/Text';
import StepInterface from './StepInterface';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import GenericInboxRecord from '../../data/GenericInboxRecord';
import { getServerValidationErrorMessages } from 'InboxConnectUtils/utils/InboxConnectionUtils';
import { CHOOSE_PROVIDER_STEP, TEST_MESSAGE_STEP, IMAP_INBOX_STEP } from 'InboxConnectUtils/constants/InboxConnectStepKeys';
import { isValidEmail } from 'InboxConnectUtils/utils/Validation';
import { transformGenericToReturnableAccount } from '../../data/transforms';
import BasicAuthConnectErrorTitle from '../errors/BasicAuthConnectErrorTitle';
import ProviderTypes from 'InboxConnectUtils/constants/ProviderTypes';
import BasicAuthConnectError from '../errors/BasicAuthConnectError';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { shouldDiscoveryBeUsed } from 'InboxConnectUtils/utils/imapDiscovery';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LANG_ROUTE = 'InboxConnectUtils.wizard.imapInbox.';
const subScreenSelector = value => {
  return value.smtpSameCreds ? 'STANDARD' : 'SPLIT';
};
class ImapInboxStep extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      didRequestDiscovery: false,
      didRequestSubmit: false,
      isAdvancedSettingsPartExpanded: false,
      value: GenericInboxRecord(),
      inboxErrors: List(),
      isAdminTemplateDiscovered: false
    };
    this.handleDiscover = this.handleDiscover.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  componentDidMount() {
    this.props.trackingClient.trackStepView(IMAP_INBOX_STEP);
  }
  componentWillUnmount() {
    this.clearErrors();
  }
  componentDidUpdate() {
    const {
      inbox: {
        id
      },
      inboxSettings
    } = this.props;
    const {
      didRequestDiscovery,
      value: {
        email
      },
      value,
      inboxErrors
    } = this.state;
    if (id) {
      this.props.trackingClient.trackStepAction(IMAP_INBOX_STEP, 'submit', {
        subAction: 'completed',
        subScreen: subScreenSelector(value)
      });
      this.props.setEmailAddress(email);
      this.props.setShownStep(TEST_MESSAGE_STEP);
      this.setState({
        didRequestSubmit: false
      });
      return;
    }
    if (0 < inboxErrors.size) {
      this.setState({
        didRequestSubmit: false
      });
    }
    const discoveredSettings = inboxSettings && inboxSettings.get(email);
    if (didRequestDiscovery && discoveredSettings) {
      this.setState(Object.assign({}, this.getNextStateParts(value, discoveredSettings), {
        didRequestDiscovery: false
      }));
      this.props.trackingClient.trackStepAction(IMAP_INBOX_STEP, 'autodiscovery');
    }
  }
  clearErrors() {
    this.setState({
      inboxErrors: this.state.inboxErrors.clear()
    });
  }
  clearError(index) {
    this.setState({
      inboxErrors: this.state.inboxErrors.delete(index)
    });
  }
  addError(inboxError) {
    this.setState({
      inboxErrors: this.state.inboxErrors.push(inboxError)
    });
  }
  getNextStateParts(value, discoveredSettings) {
    const isAdvancedSettingsPartExpanded = !(discoveredSettings && discoveredSettings.imapHost && discoveredSettings.imapPort && discoveredSettings.smtpHost && discoveredSettings.smtpPort);
    return {
      isAdvancedSettingsPartExpanded,
      value: value.merge(discoveredSettings)
    };
  }
  handleDiscover({
    email
  }) {
    if (!isValidEmail(email)) {
      return;
    }
    const {
      value
    } = this.state;
    this.setState({
      didRequestDiscovery: true,
      isAdminTemplateDiscovered: false
    });
    this.props.service.discoverInboxSettings(email).then(discoveredSettings => {
      const {
        value: valueAfterDiscover
      } = this.state;
      const useDiscoveredSettings = shouldDiscoveryBeUsed(value, valueAfterDiscover);
      if (discoveredSettings && useDiscoveredSettings) {
        if (discoveredSettings.settingsSource === 'ADMIN') {
          this.setState({
            isAdminTemplateDiscovered: true
          });
        }
      }
      const nextSettings = discoveredSettings || {};
      if (useDiscoveredSettings) {
        this.setState(this.getNextStateParts(value, nextSettings));
      }
      this.setState({
        didRequestDiscovery: Boolean(!discoveredSettings)
      });
    }).catch(() => {
      this.props.setShownStep(CHOOSE_PROVIDER_STEP);
    });
  }
  handleChange({
    target: {
      value: newValue
    }
  }) {
    this.setState({
      value: newValue
    });
  }
  handleSubmit(evt) {
    evt.preventDefault();
    this.setState({
      didRequestSubmit: true
    });
    const {
      service,
      trackingClient,
      setShownStep,
      setConnectedAccount
    } = this.props;
    const {
      value
    } = this.state;
    const openAdvancedSettings = () => this.setState({
      isAdvancedSettingsPartExpanded: true
    });
    const processInbox = inbox => {
      if (inbox.error) {
        this.addError(inbox.error);
        openAdvancedSettings();
        return;
      }
      setConnectedAccount(transformGenericToReturnableAccount(inbox));
      const {
        value: {
          email
        }
      } = this.state;
      this.props.setEmailAddress(email);
      this.props.trackingClient.trackStepAction(IMAP_INBOX_STEP, 'submit', {
        subAction: 'completed',
        subScreen: subScreenSelector(value)
      });
      setShownStep(TEST_MESSAGE_STEP);
    };
    trackingClient.trackStepAction(IMAP_INBOX_STEP, 'submit', {
      subAction: 'creating',
      subScreen: subScreenSelector(value)
    });
    this.clearErrors();
    service.createImapInbox(this.state.value).then(processInbox).catch(openAdvancedSettings).finally(() => this.setState({
      didRequestSubmit: false
    })).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
    return undefined;
  }
  render() {
    const {
      isAdvancedSettingsPartExpanded,
      didRequestDiscovery,
      didRequestSubmit,
      value,
      inboxErrors,
      isAdminTemplateDiscovered
    } = this.state;
    const lang = (key, options = {}) => /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `${LANG_ROUTE}${key}`,
      options: options
    });
    const handleOnClose = index => () => this.clearError(index);
    return /*#__PURE__*/_jsx(TFlex, {
      justify: "center",
      direction: "row",
      "data-selenium": "imap-inbox-step",
      children: /*#__PURE__*/_jsxs(Box, {
        basis: "420px",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h2",
          textAlign: "center",
          children: lang('title')
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "InboxConnectUtils.genericInboxForm.advancedSettingsHelp_jsx",
            elements: {
              UILink: Link
            },
            options: {
              href: 'https://knowledge.hubspot.com/articles/kcs_article/email-notifications/how-can-i-find-my-email-servers-imap-and-smtp-information',
              external: true
            }
          })
        }), inboxErrors && inboxErrors.map(errorCode => /*#__PURE__*/_jsx(Alert, {
          closeable: true,
          "data-errorcode": errorCode,
          onClose: handleOnClose,
          titleText: /*#__PURE__*/_jsx(BasicAuthConnectErrorTitle, {
            providerType: ProviderTypes.imap,
            errorCode: errorCode
          }),
          type: "danger",
          marginBlockEnd: "200",
          children: /*#__PURE__*/_jsx(BasicAuthConnectError, {
            providerType: ProviderTypes.imap,
            errorCode: errorCode
          })
        }, errorCode)), didRequestSubmit ? /*#__PURE__*/_jsx(LoadingSpinner, {
          grow: true,
          marginBlock: "1000"
        }) : /*#__PURE__*/_jsx(GenericInboxForm, {
          disabled: didRequestSubmit,
          handleDiscover: this.handleDiscover,
          isLoading: didRequestDiscovery || didRequestSubmit,
          isExpanded: isAdvancedSettingsPartExpanded,
          onChange: this.handleChange,
          onSubmit: this.handleSubmit,
          serverValidationErrors: getServerValidationErrorMessages(inboxErrors),
          submitText: lang('button'),
          value: value,
          isAdminTemplate: isAdminTemplateDiscovered
        })]
      })
    });
  }
}
ImapInboxStep.defaultProps = {
  inbox: GenericInboxRecord(),
  inboxSettings: ImmutableMap()
};
ImapInboxStep.propTypes = Object.assign({}, StepInterface, {
  inbox: PropTypes.instanceOf(GenericInboxRecord).isRequired,
  inboxSettings: PropTypes.instanceOf(ImmutableMap).isRequired
});
export default ImapInboxStep;